<template>
    <footer id="sel-6" class="e2-bg-top-center e2-footer e2-footer-hero">
        <div style="background: transparent;height: 15vh;"></div>
        <div class="footer-1">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-2 offset-sm-1 d-flex align-items-center mb-3 mb-sm-0 text-center">
                        <a href="https://www.sosial.gov.az">
                            <img src="/assets/images/dsmn.svg" class="w-100" alt="ARƏƏSMN" />
                        </a>
                    </div>
                    <div class="col-12 col-sm-2 d-flex align-items-center mb-3 mb-sm-0 text-center">
                        <a>
                            <img src="/assets/images/sxa_logo.svg" class="w-75" alt="SXA" />
                        </a>
                    </div>
                    <div class="col-12 col-sm-6 ms-0 ms-sm-5">
                        <div class="row">
                            <div class="col-12 col-sm-4 mt-4 mt-sm-0">
                                <h5>{{TR.menu_text}}</h5>
                                <ul class="eas-footer-links">
                                    <li>
                                        <router-link :to="{name: 'index'}">{{TR.home_page}}</router-link>
                                    </li>
                                    <li v-for="(item, index) in menus" :key="index">
                                        <router-link
                                            v-if="!item.link.match(/^#/i)"
                                            :to="{name: item.link, params: {lang: def_lang}}"
                                        >{{item.name}}</router-link>
                                        <template v-else>
                                            <a :href="item.link">{{item.name}}</a>
                                        </template>
                                    </li>
                                </ul>
                            </div>

                            <!-- <div class="col-12 col-sm-5" v-if="usefullinks">
                                <h5>{{TR.usefull_link_text}}</h5>
                                <ul class="eas-footer-links">
                                    <li v-for="(item, index) in usefullinks" :key="index">
                                        <a :href="item.link" target="blank">{{item.name}}</a>
                                    </li>
                                </ul>
                            </div> -->

                            <div class="col-12 col-sm-4 mt-4 mt-sm-0">
                                <h5>{{TR.on_mobile}}</h5>
                                <ul class="eas-footer-links">
                                    <li>
                                        <a href="https://play.google.com/store/apps/details?id=com.azetechlab.unudulmazlar" class="p-2" target="_blank"> <i class="fab fa-google-play fs-5 me-2 mt-3 mb-4"></i> Google Play</a>
                                    </li>
                                    <li>
                                        <a class="p-2" target="_blank1"> <i class="fab fa-apple fs-4 me-2"></i> Apple Store</a>
                                    </li>
                                </ul>
                            </div>

                            <div class="col-12 col-sm-4 mt-4 mt-sm-0" v-if="contacts">
                                <h5>{{TR.contact}}</h5>
                                <ul class="eas-footer-links">
                                    <li>
                                        <!-- <router-link :to="{name: 'contact', params: {lang: def_lang}}">{{contacts.address}}</router-link> -->
                                        <a href="#"><i class="fas fa-map-marker-alt me-2"></i>{{contacts.address}}</a>
                                    </li>
                                    <li>
                                        <a :href="`mailto:${contacts.email}`">
                                            <i class="fas fa-envelope me-2"></i>
                                            {{contacts.email}}
                                        </a>
                                    </li>
                                    <li>
                                        <a :href="`tel:${contacts.number}`">
                                            <i class="fas fa-phone me-2"></i>
                                            {{contacts.number}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="footer-2">
            <div class="container">
                <div class="row copyright">
                    <div class="col-md-12 text-center small p-0">
                        <p>
                            <small class="block" v-html="G.footerPowered"></small>
                        </p>
                    </div>
                </div>
            </div>
        </div> -->
    </footer>
</template>

<script >
    import { ref, watchEffect, onMounted } from "vue";
    import { useStore } from "vuex";
    import { useRoute } from "vue-router";

    import { G, ajax } from "@/_common";

    export default {
        name: 'Footer',
        props: {
            menus: {
                type: Array,
            },
        },
        setup() {
            const store = useStore();
            const route = useRoute();
            const usefullinks = ref([]);
            const contacts = ref();

            const TR = ref({});
            // const def_lang = store.getters.getLang();
            const def_lang = route.params && route.params.lang ? route.params.lang : "az";

            watchEffect(() => {
                TR.value = store.getters.getTranslations();
            });

            onMounted(async () => {
                await ajax
                    .get(store.getters.getFooterUsefulLink())
                    .then((e) => {
                        if (e && e.data && e.data.length) {
                            usefullinks.value = e.data;
                        }
                    })
                    .catch((error) => {
                        var res = error.response || {};
                    });
                await ajax
                    .get(store.getters.getFooterContactInfoLink(), {
                        params: { lang: def_lang },
                    })
                    .then((e) => {
                        if (e && e.data) {
                            contacts.value = e.data;
                        }
                    })
                    .catch((error) => {
                        var res = error.response || {};
                    });
            });

            return { G, TR, def_lang, usefullinks, contacts };
        },
    };
</script>

<style lang="scss" >
</style>
